import { AfterViewInit, Injectable } from "@angular/core";
import { BaseTemplate } from "../../../../../../shared/baseTemplate";
import { AuthService } from "../../../../../../shared/services/auth.service";
import { CurrencyExchangeService } from "../../../../../../shared/services/currency-exchange.service";
import { GetBusinessProfileService } from "../../../../../../shared/services/get-business-profile.service";
import { GetCalculatesParamsService } from "../../../../services/get-calculates-params.service";
import { ViewProductInfoHandlerService } from "../../../../services/view-product-info-handler.service";

@Injectable({
  providedIn: 'root'
})

export class BaseBooking extends BaseTemplate implements AfterViewInit {
  bookingSlotsArray: any[] = [];
  slotPrices: any[] = [];
  bookingslotsTest : any = {};

  constructor(
    public vpihs: ViewProductInfoHandlerService,
    public auth: AuthService,
    public getBusinessProfileService: GetBusinessProfileService,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService
  ) {
    super(
      vpihs,
      getBusinessProfileService,
      auth,
      exchangeService,
      getCalculatesParamsService
    );
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  getBookingQuantityArray(bookingQuantity: number) {
    const bookingQuantityArray = [];
    for (let i = 0; i < bookingQuantity; i++) {
      bookingQuantityArray.push(i);
    }
    return bookingQuantityArray;
  }

  quantityDownChange(event: any, price: number, id: number, maxQuantityPerSale: number, action?: string) {
    let booking: number = event.target.nextElementSibling.value;
    booking = booking > maxQuantityPerSale ? maxQuantityPerSale : booking;
    this.productObject.CalendarSlots.filter((slot: any) => {
      if (slot.id === id) {
        return slot;
      }
    })[0].selectedQuantity = booking;
    for (const slotPrice of this.slotPrices) {
      if (slotPrice.slotId === id) {
        slotPrice.slotQuantity = booking;
      }
    }

    let index = this.slotPrices.findIndex(
      (slotPrice) => slotPrice.slotId === id
    );
    if (index != -1) {
      if (
        this.slotPrices[index] &&
        this.slotPrices[index].slotQuantity >= 1
      ) {
        this.slotPrices[index].slotQuantity = Number(
          this.slotPrices[index].slotQuantity
        );
      } else {
        this.slotPrices.splice(index, 1);
      }
    }

    this.extrasObject = {
      isEvent: true,
      isBooking: true,
      selectedSlots: this.slotPrices,
    };
    this.quantity = this.slotPrices.length;
    this.calculateSubTotalAmount();
  }

  quantityUpChange(event: any, price: number, id: number, maxQuantityPerSale: number, action?: string) {
    let booking: number = event.target.previousElementSibling.value;
    booking = booking > maxQuantityPerSale ? maxQuantityPerSale : booking;
    this.productObject.CalendarSlots.filter((slot: any) => {
      if (slot.id === id) {
        return slot;
      }
    })[0].selectedQuantity = booking;
    for (const slotPrice of this.slotPrices) {
      if (slotPrice.slotId === id) {
        slotPrice.slotQuantity = booking;
      }
    }

    let index = this.slotPrices.findIndex(
      (slotPrice) => slotPrice.slotId === id
    );
    if (index != -1) {
      this.slotPrices[index].slotQuantity = Number(
        this.slotPrices[index].slotQuantity
      );
    } else {
      this.slotPrices.push({
        slotPrice: price,
        slotQuantity: booking,
        slotId: id,
      });
    }
    this.extrasObject = {
      isEvent: true,
      isBooking: true,
      selectedSlots: this.slotPrices,
    };
    this.quantity = this.slotPrices.length;
    this.calculateSubTotalAmount();
  }

  calculateSubTotalAmount() {
    let subtotal = 0;
    for (const slotPrice of this.slotPrices) {
      const totalSlotPrice = slotPrice["slotPrice"] * slotPrice["slotQuantity"];
      subtotal += totalSlotPrice;
    }
    this.subtotal = this.vpihs.getExchangedValue(
      subtotal,
      this.getNewProductValueByFieldName("currency", "ProductExtraInfos")
    );
    return this.subtotal;
  }

  getFeesFromSeller() {
    const feesStringValue = this.getNewProductValueByFieldName(
      "feesOnBuyerFlag",
      "ProductExtraInfos"
    );
    let netFees = 0;
    if (feesStringValue === "true" || feesStringValue === "1") {
      const feesValue = this.businessObject.fees;
      const feesType = this.businessObject.fees_type;
      if (feesType === "Percentage") {
        let amount = 0;
        for (const slotPrice of this.slotPrices) {
          const totalSlotPrice =
            slotPrice["slotPrice"] * slotPrice["slotQuantity"];
          amount += totalSlotPrice;
        }
        if (this.dicountValue < -0) {
          let discount;
          if (this.vpihs.currency != "EGP") {
            discount =
              +(
                this.dicountValue *
                this.getExchangeRateToEGP(this.vpihs.currency)
              ) || 0;
          } else {
            discount = +this.dicountValue || 0;
          }
          netFees =
            (amount - Math.abs(discount) + this.vpihs.taxes) *
            (Number(feesValue) / 100);
        } else {
          netFees = ((amount + this.vpihs.taxes) * Number(feesValue)) / 100;
        }
        console.log("netFees", netFees);
      } else {
        netFees = feesValue;
      }
      const feesObject = {
        name: "Buyer Fees",
        value: this.vpihs.getExchangedValue(netFees, this.vpihs.currency),
      };
      return feesObject;
    } else {
      return null;
    }
  }
}
